import { APIService } from "../../../../network/api/APIService";

export const EALinkListData = ({ pageFilters }) => {
    const query = {
        ...pageFilters,
        limit: "4",
    };

    const config = {
        endpoint: "/ea/link/list/",
        method: "GET",
        query: query,
        credentials: "include",
    };

    return APIService(config);
};